import IPUtility from "../classes/IPUtility";

export interface IPSchedule {
  // DB Fields
  uid: number;
  projectUID: number; // 외래 키 = IPProject
  displayOrder: number; // 표시 순서
  date: string; // 일시
  department: string; // 대상부서
  contents: string; // 내용
  note: string; // 비고

  // NotDB
  uuid: string; // UUID값
}

export const initializeIPSchedule: IPSchedule = {
  uid: 0,
  projectUID: 0,
  displayOrder: 0,
  date: IPUtility.getFullYmdStr(),
  department: "",
  contents: "",
  note: "",
  uuid: IPUtility.generateUUID(),
};

export const initializeSchedule = (
  projectUID: number,
  schedule: IPSchedule
) => {
  const newSchedule: IPSchedule = {
    uid: 0,
    projectUID: projectUID,
    displayOrder: 0,
    date: schedule.date,
    department: schedule.department,
    contents: schedule.contents,
    note: schedule.note,
    uuid: IPUtility.generateUUID(),
  };
  return { ...newSchedule };
};
